module.exports = __webpack_public_path__ + "static/CustomerMap_highres-9ed113dec86555112328e6deaaf434a5.jpg";